import { render, staticRenderFns } from "./SolicitudesCambioData.vue?vue&type=template&id=4606ec26&"
import script from "./SolicitudesCambioData.vue?vue&type=script&lang=js&"
export * from "./SolicitudesCambioData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports